import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { GoogleFreeBookingLinksSettingsI18n } from "./query";

type Props = {
	hotelID: string;
	langCode: LangCode;
};

export const useFetchGoogleFreeBookingLinksSettingsI18n = ({ hotelID, langCode }: Props) => {
	return useCustomSuspenseQuery(GoogleFreeBookingLinksSettingsI18n, {
		variables: {
			hotelID,
			langCode,
		},
	});
};
